import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=00b5d0b7"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=00b5d0b7&prod&lang=css"
import style1 from "./SplashScreen.vue?vue&type=style&index=1&id=00b5d0b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports